var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{style:(_vm.styleObject)},[_vm._v(" © Copyright "+_vm._s(_vm.currentFullYear)+" "+_vm._s(_vm.data.name)+" - Todos os direitos reservados. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }